var HOST = process.env.REACT_APP_MAU_BACKEND_URL || '';
var MAU_URL = process.env.REACT_APP_MAU_BACKEND_URL || '';
if (!HOST && (process.env.REACT_APP_NODE_ENV === 'development' || process.env.NODE_ENV === 'development')) {
    HOST = 'https://adminmau.schoolmedia.id';
    MAU_URL = 'https://mau.schoolmedia.id';
}
if (!HOST && (process.env.REACT_APP_NODE_ENV === 'staging' || process.env.NODE_ENV === 'staging')) {
    HOST = 'https://adminmaudev.schoolmedia.my.id';
    MAU_URL = 'https://maudev.schoolmedia.my.id';
}
if (!HOST && (process.env.REACT_APP_NODE_ENV === 'production' || process.env.NODE_ENV === 'production')) {
    HOST = 'https://adminmau.schoolmedia.id';
    MAU_URL = 'https://mau.schoolmedia.id';
}

export const HOSTNAME = HOST;
export const MAUURL = MAU_URL;

var API_MOBILE_URL = process.env.REACT_APP_API_MOBILE_URL || 'https://api-mobile.schoolmedia.id/api';
if (!process.env.REACT_APP_API_MOBILE_URL && (process.env.REACT_APP_NODE_ENV === 'development' || process.env.NODE_ENV === 'development')) {
    API_MOBILE_URL = 'http://localhost:3000/api';
}
export const APIMOBILE = API_MOBILE_URL;

export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL || 'https://storage.schoolmedia.id';
export const STORAGE_API_URL = `${STORAGE_URL}/api/v1`;
export const STORAGE_QUOTA_URL = `${STORAGE_URL}/api/v1/quota/detail`;